module.exports = __webpack_public_path__ + "img/arrow-head.47e40910.svg";